import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { JoinUsService } from 'src/app/services/join-us/join-us.service';
import { JobOpening } from 'src/app/models/job-opening.interface';
import { AnimationService } from 'src/app/services/animation/animation.service';

@Component({
    selector: 'app-join-our-tribe',
    templateUrl: './join-our-tribe.component.html',
    styleUrls: ['./join-our-tribe.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JoinOurTribeComponent implements OnInit {
  jobs: JobOpening[] = [];
  isLoading: boolean = true;
  error: string | null = null;

  constructor(
    private reveal: AnimationService,
    private jobService: JoinUsService
  ) { }

  ngOnInit(): void {
    this.loadJobs();
    this.reveal.reveal();
    this.reveal.revealLeft();
  }

  private loadJobs(): void {
    this.jobService.getJobs().subscribe({
      next: (jobs: JobOpening[]) => {
        this.jobs = jobs.filter(job => !job.isExecutive);
        this.isLoading = false;
        // Re-initialize animations after job elements are rendered
        setTimeout(() => {
          this.reveal.reveal();
          this.reveal.revealLeft();
        }, 0);
      },
      error: (err: Error) => {
        this.error = 'Failed to load job listings';
        this.isLoading = false;
        console.error('Error loading jobs:', err);
      }
    });
  }

  trackByJobId(index: number, job: JobOpening): string {
    return job._id;
  }
}
